a.s.schedulepicker = function(){
	var spobj = {};
	spobj.el = undefined;
	spobj.hide_sample_dates_button = false;
	// Formats
	spobj.dateformat = "YYYY-MM-DD";
	spobj.dateformat_formatted = "ddd MMM Do YYYY";
	spobj.dateformat_hour = "HH";
	spobj.dateformat_minute = "mm";
	// Input default values
	spobj.start = moment().add(1,'days').hours(8).minutes(0).seconds(0).toString();
	spobj.end = moment().add(2,'days').hours(8).minutes(0).seconds(0).toString();
	//spobj.mindate = new Date();
	spobj.past_select = false;
	spobj.disable_repetition = false;
	spobj.repetition = 'none'; // none|daily|weekly|monthly|yearly
	spobj.repeat_end = moment().add(1,'year').format(spobj.dateformat);
	spobj.ready = function(){}
	spobj.change = function(){}
	// Public
	spobj.insert = function(){
		tpl.run({tpl:'/tpl/shared/schedulepicker/main.ejs?v='+v,data:{
			hide_sample_dates_button:spobj.hide_sample_dates_button,
			disable_repetition:spobj.disable_repetition
		},cb:function(content){
			spobj.el.empty().append(content).ready(function(){
				spobj.init();
			});
		}});
	}
	spobj.isValid = function(cb_true,cb_false){
		var valid = true;
		if ($('input[name="start"]',spobj.el).val().length<10) {
			valid = false;
		}
		if ($('input[name="end"]',spobj.el).val().length<10) {
			valid = false;
		}
		if (valid) {
			cb_true();
		}
		else {
			cb_false();
		}
	}
	// Private
	spobj.init = function(){
		// Insert time date range picker
		var dtrp = a.s.datetimerangepicker();
		var dtrp_start_date = new Date();
		dtrp.el = $('[data-pickertype="datetimerange"]',spobj.el);
		dtrp.timeformat = a.userinfo.timeformat;
		dtrp.calendar_width = 740;
		dtrp.start_datetime = new Date(spobj.start);
		dtrp.end_datetime = new Date(spobj.end);
		//dtrp.mindate = spobj.mindate;
		dtrp.past_select = spobj.past_select;
		dtrp.ready = function(){}
		dtrp.change = function(){
			if (dtrp.valid_output) {
				$('input[name="start"]',spobj.el).val(dtrp.output_start);
				$('input[name="end"]',spobj.el).val(dtrp.output_end);
				spobj.checkValidRepetitions(moment.duration(moment(dtrp.output_end).diff(moment(dtrp.output_start))).asHours());
			}
			else {
				$('input[name="start"]',spobj.el).val('');
				$('input[name="end"]',spobj.el).val('');
			}
			spobj.change();
		}
		dtrp.insert();
		// Repetition
		$('ul[data-select="repetition"]>li',spobj.el).unbind('click').click(function(){
			if (!$(this).hasClass('disabled')) {
				$(this).addClass('active').siblings().removeClass('active');
				$('input[name="repetition"]',spobj.el).val($(this).attr('data-value'));
				spobj.DSChangeUI.repType($('input[name="repetition"]',spobj.el),spobj.el);
			}
			else {
				a.s.growl.create('Too long date range','You must decrease your date/time range to avoid overlapping reservations',{duration:5000});
			}
		});
		$('input[name="repetition"]',spobj.el).val(spobj.repetition);
		$('ul[data-select="repetition"]>li[data-value="'+spobj.repetition+'"]',spobj.el).addClass('active').siblings().removeClass('active');
		$('input[name="repetition"]',spobj.el).unbind('change').change(function(){
			spobj.DSChangeUI.repType(this);
		});
		spobj.DSChangeUI.repType($('input[name="repetition"]',spobj.el),spobj.el);
		$('select[name="repeat_end"]',spobj.el).unbind('change').change(function(){
			spobj.DSChangeUI.repEnd(this);
		});
		spobj.DSChangeUI.repEnd($('select[name="repeat_end"]',spobj.el),spobj.el);
		$('input[name="rep_month_type"]',spobj.el).unbind('change').change(function(){
			spobj.DSChangeUI.repMonthType(this);
		});
		spobj.DSChangeUI.repMonthType($('input[name="rep_month_type"]:checked',spobj.el),spobj.el);
		$('input[name="rep_year_day_bool"]',spobj.el).unbind('change').change(function(){
			spobj.DSChangeUI.repYearDayBool(this);
		});
		spobj.DSChangeUI.repYearDayBool($('input[name="rep_year_day_bool"]',spobj.el),spobj.el);
		// Repeat list
		$('button[data-action="show-repeat-eventlist"]',spobj.el).unbind('click').click(function(){
			spobj.showRepeatEventList();
		});
		// End date picker
		$('[data-action="datepicker_repeat_end"]',spobj.el).unbind('click').click(function(){
			a.s.popup_datepicker.popup({
				title:'Select end date',
				selected_date:$('input[name="date_repeat_end"]',spobj.el).val(),
				min_date:$('input[name="start"]',spobj.el).val(),
				returndate:function(date){
					$('input[name="date_repeat_end"]',spobj.el).val(date);
					$('div[data-area="date_repeat_end"]',spobj.el).text(moment(date).format(spobj.dateformat_formatted));
					spobj.change();
				}
			});
		});
		// Insert default/input values
		$('input[name="date_repeat_end"]',spobj.el).val(spobj.repeat_end);
		$('div[data-area="date_repeat_end"]',spobj.el).text(moment(spobj.repeat_end).format(spobj.dateformat_formatted));
		spobj.change();
	}
	spobj.DSChangeUI = {};
	spobj.DSChangeUI.repType = function(el) {
		var rep = $(el).val();
		$('*[data-show-on-repeat="true"]',spobj.el).hide();
		$('*[data-hide-on-repeat-change="true"]',spobj.el).hide();
		if (rep!=='none') {
			$('*[data-show-on-repeat="true"]',spobj.el).show();
			$('*[data-show-on-repetition="'+rep+'"]',spobj.el).show();
		}
		spobj.change();
	}
	spobj.DSChangeUI.repEnd = function(el){
		if ($(':selected',el).val()=='date_repeat_end') {
			$('div[data-show-on-repeat-end="date"]',spobj.el).show();
			$('div[data-show-on-repeat-end="times"]',spobj.el).hide();
			$('div[data-show-on-repeat-end="none"]',spobj.el).hide();
		}
		else if ($(':selected',el).val()=='times_repeat_end') {
			$('div[data-show-on-repeat-end="date"]',spobj.el).hide();
			$('div[data-show-on-repeat-end="times"]',spobj.el).show();
			$('div[data-show-on-repeat-end="none"]',spobj.el).hide();
		}
		else {
			$('div[data-show-on-repeat-end="date"]',spobj.el).hide();
			$('div[data-show-on-repeat-end="times"]',spobj.el).hide();
			$('div[data-show-on-repeat-end="none"]',spobj.el).show();
		}
		spobj.change();
	}
	spobj.DSChangeUI.repMonthType = function(el) {
		if ($(el).val()=='day') {
			$('select[name="rep_month_day_interval"]',spobj.el).prop('disabled',false);
			$('select[name="rep_month_day"]',spobj.el).prop('disabled',false);
			$('select[name="rep_month_dates[]"]',spobj.el).prop('disabled',true);
		}
		else {
			$('select[name="rep_month_day_interval"]',spobj.el).prop('disabled',true);
			$('select[name="rep_month_day"]',spobj.el).prop('disabled',true);
			$('select[name="rep_month_dates[]"]',spobj.el).prop('disabled',false);
		}
		spobj.change();
	}
	spobj.DSChangeUI.repYearDayBool = function(el) {
		if ($(el).prop('checked')) {
			$('select[name="rep_year_day_interval"]',spobj.el).prop('disabled',false);
			$('select[name="rep_year_day"]',spobj.el).prop('disabled',false);
		}
		else {
			$('select[name="rep_year_day_interval"]',spobj.el).prop('disabled',true);
			$('select[name="rep_year_day"]',spobj.el).prop('disabled',true);
		}
		spobj.change();
	}
	spobj.DSChangeUI.calcEndFromDuration = function() {
		// format
		var dateformat = "YYYY-MM-DD";
		var dateformat_formatted = "dddd MMMM Do YYYY, HH:mm (h:mm a)";
		var dateformat_hour = "HH";
		var dateformat_minute = "mm";
		// Calculate
		var dateStr = $('input[name="date_start"]',spobj.el).val()+' '+$('select[name="hour_start"]>option:selected',spobj.el).val()+':'+$('select[name="minute_start"]>option:selected',spobj.el).val()+':00';
		var date = moment(dateStr).add($('select[name="duration_days"]',spobj.el).val(),'days').add($('select[name="duration_hours"]',spobj.el).val(),'hours').add($('select[name="duration_minutes"]',spobj.el).val(),'minutes');
		// Insert
		$('input[name="date_end"]',spobj.el).val(moment(date).format(dateformat));
		$('input[name="hour_end"]',spobj.el).val(moment(date).format(dateformat_hour));
		$('input[name="minute_end"]',spobj.el).val(moment(date).format(dateformat_minute));
		$('span[data-area="date_end"]',spobj.el).text(moment(date).format(dateformat_formatted));
		spobj.change();
	}
	spobj.showRepeatEventList = function(){
		spobj.loadRepeatEventList(function(result){
			if (result.success && result.list) {
				tpl.run({tpl:res_path+'tpl/schedule/new/sample_day_list.ejs?v='+v,data:result,cb:function(content){
					var token = a.s.popup.create({
						title:'Repeating appointment days (sample)',
						width:500,
						height:500,
						content:content,
						show_actions:false,
						ready:function(token){
							
						}
					});
				}});
			}
			else {
				a.s.growl.create('No appointments','There will be no appointments within this time range',{duration:5000});
			}
		});
	}
	spobj.loadRepeatEventList = function(cb){
		$.ajax({
			type:'GET',
			url:'/api/reservation/calc_recurring_events/',
			data:{
				'start':$('input[name="start"]',spobj.el).val(),
				'end':$('input[name="end"]',spobj.el).val(),
				'repetition':$('input[name="repetition"]',spobj.el).val(),
				'rep_daily_interval':$('input[name="rep_daily_interval"]',spobj.el).val(),
				'rep_weekly_interval':$('input[name="rep_weekly_interval"]',spobj.el).val(),
				'rep_day':$('select[name="rep_day[]"] :selected',spobj.el).map(function(i,el){return $(el).val();}).get(),
				'rep_monthly_interval':$('input[name="rep_monthly_interval"]',spobj.el).val(),
				'rep_month_type':$('input[name="rep_month_type"]',spobj.el).val(),
				'rep_month_dates':$('select[name="rep_month_dates[]"] :selected',spobj.el).map(function(i,el){return $(el).val();}).get(),
				'rep_month_day_interval':$('select[name="rep_month_day_interval"] :selected',spobj.el).val(),
				'rep_month_day':$('select[name="rep_month_day"] :selected',spobj.el).val(),
				'rep_yearly_interval':$('input[name="rep_yearly_interval"]',spobj.el).val(),
				'rep_year_months':$('select[name="rep_year_months[]"] :selected',spobj.el).map(function(i,el){return $(el).val();}).get(),
				'rep_year_day_bool':$('input[name="rep_year_day_bool"]:checked',spobj.el).val(),
				'rep_year_day_interval':$('select[name="rep_year_day_interval"] :selected',spobj.el).val(),
				'rep_year_day':$('select[name="rep_year_day"] :selected',spobj.el).val(),
				'repeat_end':$('select[name="repeat_end"] :selected',spobj.el).val(),
				'date_repeat_end':$('input[name="date_repeat_end"]',spobj.el).val(),
				'times_repeat_end':$('input[name="times_repeat_end"]',spobj.el).val()
			},
			dataType:'json',
			cache: false,
			success:function(result) {
				cb(result);
			}
		});
	}
	spobj.checkValidRepetitions = function (hours) {
		$('[data-select="repetition"]>li',spobj.el).removeClass('disabled');
		// Daily = 24 hours
		if (hours>24) {
			spobj.disableRepOption('daily');
		}
		// Weekly = 7 days
		if (hours>168) {
			spobj.disableRepOption('weekly');
		}
		// Monthly = 28 days
		if (hours>672) {
			spobj.disableRepOption('monthly');
		}
		// Yearly = 365 days
		if (hours>8760) {
			spobj.disableRepOption('yearly');
		}
	}
	spobj.disableRepOption = function (opt) {
		$('[data-select="repetition"]>li[data-value="'+opt+'"]',spobj.el).addClass('disabled');
		if ($('input[name="repetition"]',spobj.el).val()==opt) {
			spobj.resetRep();
		}
	}
	spobj.resetRep = function () {
		$('[data-select="repetition"]>li[data-value="none"]',spobj.el).addClass('active').siblings().removeClass('active');
		$('input[name="repetition"]',spobj.el).val('none');
		spobj.DSChangeUI.repType($('input[name="repetition"]',spobj.el));
	}
	spobj.getFilterWithResDates = function(cb,rid) {
		var filter = {
			'res_period':[],
			'ignore_reservation_id':rid
		};
		if ($('input[name="start"]',spobj.el).val().length>10 && $('input[name="end"]',spobj.el).val().length>10) {
			filter.res_period.push($('input[name="start"]',spobj.el).val().replace(' ','T')+';'+$('input[name="end"]',spobj.el).val().replace(' ','T'));
		}
		if ($('input[name="repetition"]',spobj.el).val()!=='none') {
			spobj.loadRepeatEventList(function(res){
				if (res.success && res.list) {
					var resp = res.list.map(function(e){
						return e.start.replace(' ','T')+';'+e.end.replace(' ','T');
					});
					filter.res_period = filter.res_period.concat(resp);
					if (filter.res_period.length>0) {
						cb(filter);
					}
				}
				else {
					if (filter.res_period.length>0) {
						cb(filter);
					}
				}
			});
		}
		else {
			if (filter.res_period.length>0) {
				cb(filter);
			}
		}
	}
	return spobj;
}